<div>
	<h4><mat-icon>bar_chart</mat-icon> Summary</h4>
	<dl class="dl-style">
		<dt class="dt-style" [ngStyle]="{'grid-template-columns': params.gridTemplateColumns}"
			*ngFor="let item of params?.summaryData">
			<span>{{ item.label }}:</span>
			<span [class.primary]="item.primary">{{ item.value }}</span>
		</dt>
	</dl>
	<dd class="dd-style">{{params?.footnote}}</dd>
</div>